"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveFacilityId = useActiveFacilityId;
var hooks_1 = require("../store/hooks");
function useActiveFacilityId() {
    return (0, hooks_1.useAppSelector)(function (state) { var _a; return (_a = state.facility.facility) === null || _a === void 0 ? void 0 : _a.id; });
}
